import { Pipe, PipeTransform } from '@angular/core';
import { formatPhoneNumber } from '../helpers/phone';

/** Display a stored phone value as (123)-456-7890 (e.g. in read-only mode). */
@Pipe({
  name: 'phone',
  standalone: true,
})
export class PhonePipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    return formatPhoneNumber(value);
  }
}
